/* eslint-disable node/handle-callback-err */
import type { ExtendedError, GraphQLError } from './types';

/**
 * GrapqhQL returns errors like:
 * GraphQL error: Couldn't find Academy::Article with [WHERE "academy_articles"."slug" = $1]
 *
 * Don't include it to `willSendToSentry`, because we need to track those error explicitly
 */
export const isGQLNotFound = (error: ExtendedError) => {
  return error?.graphQLErrors?.some((e: GraphQLError) => {
    return e.message?.includes("Couldn't find");
  });
};

/**
 * Decide is it useful error or not
 */
export const willSendToSentry = (error: ExtendedError) => {
  const statusCode = String(error.response?.status || error.status || error.name);

  // Filter 404 and 429 errors
  return !(statusCode.includes('404') || statusCode.includes('429'));
};

export const isLocalstorageAvailable = (() => {
  const test = 'test';
  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
})();
